import { useState } from "react";

export function useLocalStorage<TValue>(keyName: string, defaultValue: TValue | null) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const value = window.localStorage.getItem(keyName);
            
            if (value) {
                return JSON.parse(value);
            } else {
                window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
                return defaultValue;
            }
        } catch (err) {
            return defaultValue;
        }
    });
    
    const setValue = (value: TValue | null): void => {
        try {
            window.localStorage.setItem(keyName, JSON.stringify(value));
        } catch (err) {
            console.log(err);
        }
        
        setStoredValue(value);
    };
    
    return [storedValue, setValue];
}